// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-dialog-content {
  min-width: 600px;
  min-height: 200px;
  padding: 2px 24px !important;
  background-color: #f0f0f0;
}

mat-dialog-actions {
  background-color: #f0f0f0;
  padding: 8px 24px !important;
}

.content {
  padding: 16px;
  border-radius: 4px;
}

.button-gap {
  gap: 12px;
}

.content-row {
  padding: 0 15px 8px;
  color: #000;
  overflow-x: hidden;
}

.sub-label {
  margin: 6px 0 4px 0;
  font-size: 16px;
  font-weight: 500;
}

.sub-label-small {
  margin: 4px 0 2px 0;
  font-size: 16px;
  font-weight: 500;
}

.checkbox-row,
.radio-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 3px 0;
  font-size: 16px;
}

.compliance-tests-section {
  margin-left: 24px;
  margin-bottom: 4px;
  padding: 6px 8px;
  border-radius: 4px;
  font-size: 16px;
}

.compliance-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 2px 12px;
  margin-top: 4px;
}

.compliance-grid .checkbox-row {
  margin: 1px 0;
  font-size: 14px;
}

.grid-item {
  white-space: normal;
  word-break: break-word;
}

.comments-row {
  margin-top: 6px;
  display: grid;
  grid-template-columns: 90px 1fr;
  align-items: start;
  gap: 8px;
}

.comments-row label {
  padding-top: 6px;
  font-size: 16px;
}

.comments-row textarea {
  width: 100%;
  resize: none;
  border: 1px solid #DBDCDD;
  border-radius: 3px;
  padding: 6px;
  font-size: 12px;
}

.state-row {
  padding: 8px 12px;
  font-size: 13px;
}

.state-row.error {
  color: #b30000;
}

.link-button {
  margin-left: 8px;
  border: none;
  background: transparent;
  color: #005da8;
  text-decoration: underline;
  cursor: pointer;
  font-size: 13px;
}

.radio-input {
  accent-color: #0066B2;
}

`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/add-new-spacer-modal/add-new-spacer-modal.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":["mat-dialog-content {\n  min-width: 600px;\n  min-height: 200px;\n  padding: 2px 24px !important;\n  background-color: #f0f0f0;\n}\n\nmat-dialog-actions {\n  background-color: #f0f0f0;\n  padding: 8px 24px !important;\n}\n\n.content {\n  padding: 16px;\n  border-radius: 4px;\n}\n\n.button-gap {\n  gap: 12px;\n}\n\n.content-row {\n  padding: 0 15px 8px;\n  color: #000;\n  overflow-x: hidden;\n}\n\n.sub-label {\n  margin: 6px 0 4px 0;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.sub-label-small {\n  margin: 4px 0 2px 0;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.checkbox-row,\n.radio-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin: 3px 0;\n  font-size: 16px;\n}\n\n.compliance-tests-section {\n  margin-left: 24px;\n  margin-bottom: 4px;\n  padding: 6px 8px;\n  border-radius: 4px;\n  font-size: 16px;\n}\n\n.compliance-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 2px 12px;\n  margin-top: 4px;\n}\n\n.compliance-grid .checkbox-row {\n  margin: 1px 0;\n  font-size: 14px;\n}\n\n.grid-item {\n  white-space: normal;\n  word-break: break-word;\n}\n\n.comments-row {\n  margin-top: 6px;\n  display: grid;\n  grid-template-columns: 90px 1fr;\n  align-items: start;\n  gap: 8px;\n}\n\n.comments-row label {\n  padding-top: 6px;\n  font-size: 16px;\n}\n\n.comments-row textarea {\n  width: 100%;\n  resize: none;\n  border: 1px solid #DBDCDD;\n  border-radius: 3px;\n  padding: 6px;\n  font-size: 12px;\n}\n\n.state-row {\n  padding: 8px 12px;\n  font-size: 13px;\n}\n\n.state-row.error {\n  color: #b30000;\n}\n\n.link-button {\n  margin-left: 8px;\n  border: none;\n  background: transparent;\n  color: #005da8;\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: 13px;\n}\n\n.radio-input {\n  accent-color: #0066B2;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
